import { MinTableKey } from "./table";

export const FEEDBACK_STATUS = {
  NEW: "new",
  REVIEWED: "reviewed",
  ACTIONED: "actioned",
  DECLINED: "declined",
} as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUS)[keyof typeof FEEDBACK_STATUS];

export type FeedbackData = {
  type: "feedback";
  id: string;
  userId: string; // the submitter — feedback lives in their own partition like everything else
  text: string;
  page?: string;
  status: FeedbackStatus;
  resolutionNote?: string;
  createdAt: string;
  updatedAt: string;
};

// GSI1 (sparse — only feedback items set these) lets a single Query answer
// "all feedback across every user", which the base table's per-user
// partitioning can't do on its own. GSI1SK is `{status}#{createdAt}#{id}` so
// `begins_with(GSI1SK, "new#")` fetches only unreviewed items directly, and
// items stay date-ordered within a status.
export type FeedbackDBData = MinTableKey & FeedbackData;
